<template>
  <div class="rounded-xl overflow-hidden d-flex flex-grow-1 full-width">
    <v-data-table
      disable-pagination
      hide-default-footer
      dense
      fixed-header
      :headers="headers"
      :items="items"
      :custom-sort="onSort"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      height="200px"
      style="overflow: hidden; border-radius: 20px; width: 100%"
    >
      <template v-slot:item.betriebshofId="{ item }">
        <v-chip small color="primary" dark> {{ getBetriebshofFrom(item) }}</v-chip>
      </template>
      <template v-slot:item.vbzNr="{ item }"> {{ mx_isDispoView ? item.vbzNr : resolvedVbzNr(item.vbzNr) }}</template>
      <template v-slot:item.fromTo="{ item }">
        <v-chip small class="my-2" color="primary" dark>
          {{ formatTime(item.start) }} -
          {{ formatTime(item.end) }}
        </v-chip>
      </template>

      <template v-slot:top>
        <div class="d-flex pl-4 pr-10 pt-1 align-center">
          <div class="d-flex flex-column justify-start align-center">
            <v-badge v-if="badgeValue > 0" :content="badgeValue" color="error" offset-y="14" offset-x="-4">
              <div class="text-h6">Pikett</div>
            </v-badge>
            <div v-else class="text-h6">Pikett</div>
          </div>
          <v-spacer></v-spacer>
          <div class="d-flex flex-column align-end mr-8 d-print-none" style="margin-top: -6px">
            <v-btn-toggle v-if="mx_isDispoView || mx_isZueri9View" mandatory rounded v-model="pikettDisplayMode" color="primary">
              <v-btn small value="active">aktive</v-btn>
              <v-btn small value="all">alle</v-btn>
              <v-btn small value="deleted">gelöschte</v-btn>
            </v-btn-toggle>
          </div>

          <!-- Edit dialog -->
          <v-dialog v-if="mx_isDispoView || mx_isZueri9View" v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="mx_isDispoView || mx_isZueri9View" outlined color="primary" @click="prepareNewItem" dark class="mb-2" small v-bind="attrs" v-on="on">
                Neuer Eintrag
              </v-btn>
            </template>

            <v-card @keydown.enter="validateAndSave">
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="editFormValid">
                    <v-row>
                      <v-col cols="6" class="py-0 d-flex">
                        <v-dialog v-model="isPerson1LookupDialogOpen" width="500" height="600">
                          <person-autocomplete
                            :vbzNrString="editedItem.vbzNr"
                            label="Suche Mitarbeiter*in"
                            @cancel="isPerson1LookupDialogOpen = false"
                            @save="savePerson"
                          ></person-autocomplete>
                        </v-dialog>
                        <v-btn
                          v-if="mx_isDispoView || (mx_isZueri9View && !editedItem.id)"
                          class="mt-6 move-minus-10"
                          icon
                          @click="isPerson1LookupDialogOpen = true"
                        >
                          <v-icon size="20" @click="isPerson1LookupDialogOpen = true">mdi-account-search</v-icon>
                        </v-btn>
                        <v-text-field
                          :disabled="mx_isZueri9View && !!editedItem.id"
                          class="d-flex mt-4"
                          clearable
                          v-model="editedItem.vbzNr"
                          label="VBZ Nr.*"
                          placeholder="VBZ Nr. erfassen*"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="Name" :value="employeeName" readonly disabled></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-select
                          v-model="editedItem.betriebshofId"
                          :items="betriebshofList"
                          item-text="text"
                          item-value="id"
                          placeholder="BB/BT erfassen"
                          label="BB/BT"
                          :rules="betriebshofRules"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <time-field
                          required
                          v-model="editedItem.start"
                          :defaultDate="currentDate"
                          label="von *"
                          placeholder="Pikett von hh:mm"
                          :rules="startRules"
                        ></time-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <time-field
                          required
                          :rules="endRules"
                          v-model="editedItem.end"
                          :defaultDate="currentDate"
                          placeholder="Pikett bis hh:mm"
                          label="bis *"
                        ></time-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field v-model="editedItem.phone" clearable :rules="phoneRules" placeholder="Telefon" label="Telefon *"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.remark" clearable placeholder="Bemerkung" label="Bemerkung"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close"> Abbrechen</v-btn>
                <!--                <v-btn color="primary" text @click="toggleDeleteState">löschen</v-btn>-->
                <v-btn color="primary" text :disabled="!editFormValid" @click="validateAndSave"> Speichern</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Zeile {{ editedItem.deleted ? 'reaktivieren' : 'löschen' }}?</v-card-title>
              <v-card-text>Wollen Sie den Eintrag wirklich {{ editedItem.deleted ? 'reaktivieren' : 'löschen' }}? </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeDeleteDialog">Abbrechen</v-btn>
                <v-btn color="primary" text @click="toggleDeleteStateConfirmed">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>

      <!-- Table column slots -->
      <template v-slot:item.actions="{ item }">
        <div v-if="!item.lock" :class="rowClassMarker(item)">
          <v-badge v-if="item.receivedAt > 0" :content="item.changeType" left color="error"> </v-badge>
          <v-btn :disabled="isAssignedToDifferentView(item)" small icon @click="editItem(item)">
            <v-icon small class="mr-2"> mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="mx_isDispoView || mx_isZueri9View" :disabled="!canBeDeleted(item)" small icon @click="toggleDeleteState(item)">
            <v-icon small>
              {{ item.deleted ? 'mdi-delete-off' : 'mdi-delete' }}
            </v-icon>
          </v-btn>
          <v-btn
            :disabled="isAssignedToDifferentView(item) && item.deleted"
            small
            icon
            v-if="mx_isDispoView && !isAssignedToDifferentView(item)"
            @click="forwardItem(item)"
          >
            <v-icon title="Weiterleiten" class="mx-1">mdi-share </v-icon>
          </v-btn>
          <v-btn v-else-if="mx_isDispoView" @click="restoreForwardedItem(item)" small icon :disabled="item.deleted">
            <v-icon title="Zurücknehmen" class="mx-1"> mdi-restore </v-icon>
          </v-btn>
        </div>
        <div v-else class="d-flex flex-column align-center justify-center">
          <v-icon color="error" small>mdi-lock-outline</v-icon>
          <div style="font-size: 7px">{{ item.lock.firstName }} {{ item.lock.lastName }}</div>
        </div>
      </template>
      <template v-slot:no-data> {{ $t('no_data') }} </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';
import dateUtils from '../../../../common/dateUtils';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import sortFunctions from '@/sorters/sortFunctions';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import PersonAutocomplete from '@/modules/customerVbzWorksheet/components/PersonAutocomplete.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import constants from '../../constants';
import TimeField from '@/modules/customerVbzWorksheet/components/TimeField.vue';

const defaultPikettItem = { vbzNr: null, start: '', end: null, remark: '', phone: null };
const DOMAIN = 'pikett';
const headers = [
  {
    text: 'VBZ Nr.',
    align: 'start',
    sortable: true,
    value: 'vbzNr',
    width: '180px',
  },
  {
    text: 'BB/BT',
    align: 'center',
    sortable: true,
    value: 'betriebshofId',
    width: '90px',
    sorter: (items, field, isDesc, lookupObjects) => {
      let { betriebshofList } = lookupObjects;
      return items.sort((a, b) => {
        let betriebshofA = betriebshofList.find((item) => item.id === a.betriebshofId);
        let betriebshofB = betriebshofList.find((item) => item.id === b.betriebshofId);
        let valueA = betriebshofA ? betriebshofA.text : null;
        let valueB = betriebshofA ? betriebshofB.text : null;
        return sortFunctions.compareValues(valueA, valueB, { order: isDesc ? 'desc' : 'asc' });
      });
    },
  },
  {
    text: 'von - bis',
    align: 'center',
    sortable: true,
    value: 'fromTo',
    width: '120px',
    sorter: (items, fieldId, isDesc, lookupObjects) => {
      return sortFunctions.sort(items, 'start', { order: isDesc ? 'desc' : 'asc', isParseableDateString: true });
    },
  },
  {
    text: 'Telefon',
    align: 'start',
    sortable: true,
    value: 'phone',
    width: '150px',
  },
  {
    text: 'Bemerkung',
    align: 'start',
    sortable: true,
    value: 'remark',
  },
  { text: 'Aktionen', value: 'actions', sortable: false, align: 'center', width: '120px' },
];
export default {
  mixins: [dateTimeMixin, wsMixin],
  components: { TimeField, PersonAutocomplete },
  props: {
    badgeValue: Number,
    badgeColor: String,
  },
  created() {
    this.$socket.on('domain:lockItem', ({ domain, id, username, firstName, lastName }) => {
      console.debug(`User ${firstName} ${lastName} has locked ${domain} item with id ${id}`);
      if (domain === DOMAIN && this.items) {
        let itemWithId = this.items.find((item) => item.id === id);
        if (itemWithId) {
          Vue.set(itemWithId, 'lock', { username, firstName, lastName });
        }
      }
    });
    this.$socket.on('domain:releaseLockedItem', ({ domain, id, username, firstName, lastName }) => {
      console.debug(`User ${firstName} ${lastName} has releaseLockedItem ${domain} item with id ${id}`);
      if (domain === DOMAIN && this.items) {
        let itemWithId = this.items.find((item) => item.id === id);
        if (itemWithId) {
          Vue.delete(itemWithId, 'lock');
        }
      }
    });
  },

  beforeUpdate() {
    //setTimeout(() => {
    console.debug('make sure, the room is joined.');
    this.$socket.emit('join-room', { room: 'vbzWorksheet' }, (response) => {
      console.debug(`join-room response: Status=${response.status} Message=${response.msg}`);
    });
    // }, 10000);
  },

  data: () => ({
    isPerson1LookupDialogOpen: false,
    dialog: false,
    dialogDelete: false,
    headers,
    editedIndex: -1,
    editedItem: {},

    editFormValid: true,
    vbzNrRules: [(v) => !!v || 'VbzNr ist erforderlich'],
    startRules: [(v) => !!v || 'Beginn ist erforderlich'],
    endRules: [(v) => !!v || 'Ende ist erforderlich'],
    phoneRules: [(v) => !!v || 'Telefon ist erforderlich'],
    betriebshofRules: [(v) => !!v || 'BB/BT ist erforderlich'],

    sortBy: 'von - bis',
    sortDesc: false,

    pikettDisplayMode: 'active',
  }),

  computed: {
    ...mapState('vbzWorksheet', ['piketts']),
    ...mapState('vbzWorksheet', ['remarks', 'remarksById', 'pikettsByDate', 'betriebshofsById', 'userByCompanyNr']),
    ...mapState('vbzWorksheet', {
      betriebshofList: (state) => state.betriebshofs,
      currentDate: (state) => state.contextDate,
    }),

    employeeName() {
      let companyNr = this.editedItem.vbzNr || '';
      return this.mx_formatUserFromCompanyNrWithNoCompanyNr(companyNr);
    },
    items() {
      let deletedOnly = this.pikettDisplayMode === 'deleted';
      let ignoreDeleted = this.pikettDisplayMode === 'active';
      let currentDayKey = worksheetService.buildDateIdFromDate(this.currentDate);

      let pikettsCurrentDay = this.pikettsByDate[currentDayKey];
      let dataFilterEnabled = false; //no data filtering required due to pre-filtering in pikettsCurrentDay

      let filtered = worksheetService.filterItems(this.currentDate, pikettsCurrentDay, deletedOnly, ignoreDeleted, 'start', dataFilterEnabled);
      if (this.mx_isZueri9View) {
        filtered = filtered.filter((i) => i.assignedTo === 'zueri9');
      } else {
        filtered = filtered.filter((i) => i.createdInView !== 'zueri9');
      }

      return filtered;
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Neuer Eintrag' : 'Eintrag editieren';
    },
  },

  methods: {
    ...mapMutations('vbzWorksheet', ['pushDomainItem']),
    resolvedVbzNr(vbzNr) {
      return this.mx_formatUserFromCompanyNr(vbzNr);
    },
    savePerson(vbzNr) {
      this.isPerson1LookupDialogOpen = false;
      let user = this.userByCompanyNr[vbzNr];
      if (user && user.phone) {
        this.editedItem.phone = user.phone;
      }
      this.editedItem.vbzNr = vbzNr;
    },
    /**
     * Callback of the vuetify table to sort items according the provided parameters
     * @param {Array<Object>} items - The data array. Each row is an array item. No slicing necessary here (usually required to not break reactivity)
     * @param {Array<String>} sortableFieldsArr - This is an array with ONE string that matches the columnHeader <value> property and defines the column to sort
     * @param {Array<Boolean>} isDescArr - This is an array with ONE boolean value that is true to define the sort order to DESCENDING
     * @return the sorted items
     */
    onSort(items, sortableFieldsArr, isDescArr) {
      let isDesc = isDescArr[0];
      let fieldId = sortableFieldsArr[0];
      let header = this.headers.find((h) => h.value === fieldId);
      let additionalObjects = { betriebshofList: this.betriebshofList };
      if (header && header.sorter) {
        return header.sorter(items, fieldId, isDesc, additionalObjects);
      }

      let sorted = sortFunctions.sort(items, fieldId, { order: isDesc ? 'desc' : 'asc' });
      return sorted;
    },
    rowClassMarker(item) {
      let clz = item._updated === true ? 'is-highlighted' : '';
      return `${clz}${item.deleted ? ` text--disabled` : ''}${this.isAssignedToDifferentView(item) ? ' is-forwarded' : ''}`;
    },
    isAssignedToDifferentView(item) {
      return (item.assignedTo === 'dispo' && this.mx_isZueri9View) || (item.assignedTo === 'zueri9' && this.mx_isDispoView);
    },
    canBeDeleted(item) {
      return (this.mx_isDispoView && item.assignedTo === 'dispo') || (this.mx_isZueri9View && item.createdInView === 'zueri9');
    },
    forwardItem(item) {
      item.assignedTo = !item.assignedTo || item.assignedTo === 'dispo' ? 'zueri9' : 'dispo';
      console.debug('forwarded item to', item.assignedTo);
      this.saveItem(item);
    },
    restoreForwardedItem(item) {
      this.forwardItem(item);
    },
    getBetriebshofFrom(pikett) {
      // let betriebshof = this.betriebshofList.filter((item) => item.id === pikett.betriebshofId);
      let betriebshof = this.betriebshofsById[pikett.betriebshofId];
      if (betriebshof) {
        return betriebshof.text;
      }
      return `unbekannte id ${pikett.betriebshofId}`;
    },
    formatTime(isoString) {
      return dateUtils.formatTime(isoString);
    },

    validate() {
      return this.$refs.form.validate();
    },
    prepareNewItem() {
      this.reset();
      this.editedItem = { vbzNr: '', assignedTo: this.mx_isZueri9View ? 'zueri9' : 'dispo' };
    },
    reset() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      });
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    // Find the edited item within the list of items and store it as state
    setEditedItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },

    editItem(item) {
      console.debug('editItem');
      this.setEditedItem(item);
      this.dialog = true;

      // lock row
      this.sendLock(item);
    },
    // 1. triggered on button click
    toggleDeleteState(item) {
      // lock row
      this.sendLock(item);

      this.setEditedItem(item);
      this.dialogDelete = true;
    },

    // 2. deletion or reactivation confirmed by user in dialog
    toggleDeleteStateConfirmed() {
      const editedItem = this.items[this.editedIndex];
      this.$socket.emit('domain:delete', DOMAIN, this.editedItem, (response) => {
        // soft delete
        console.debug(`delete item command stored via socket. Response status:${response.status}: item: ${JSON.stringify(response.softDeleted, null, 2)}`);
        // "this" is bound to the callback here. Thus no usage of this.items.. here
        editedItem.deleted = response.softDeleted.deleted;
      });
      this.closeDeleteDialog();
    },
    sendLock(item) {
      this.$socket.emit('domain:lockItem', { domain: DOMAIN, id: item.id }, (response) => {
        console.debug(`domain pikett locked item ${item.id} ${response.status} Message=${response.msg}`);
      });
    },
    sendLockReleased(item) {
      this.$socket.emit('domain:releaseLockedItem', { domain: DOMAIN, id: item.id }, (response) => {
        console.debug(`domain pikett releaseLockedItem item ${item.id} ${response.status} Message=${response.msg}`);
      });
    },

    close() {
      this.dialog = false;
      this.editFormValid = false;
      this.sendLockReleased(this.editedItem);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, defaultPikettItem);
        this.editedIndex = -1;
      });
    },

    closeDeleteDialog() {
      this.dialogDelete = false;
      this.sendLockReleased(this.editedItem);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, defaultPikettItem);
        this.editedIndex = -1;
      });
    },
    validateAndSave() {
      if (this.validate()) this.save();
    },
    saveItem(item) {
      if (item.id) {
        // Update item
        // let itemAtIndex = this.items[this.editedIndex];
        this.$socket.emit('domain:update', DOMAIN, item, (response) => {
          Object.assign(item, response.data);
          item.isAuthor = true;
          this.close();
        });
      } else {
        // Create item
        item.recordDate = this.currentDate;
        console.debug(`create item ${JSON.stringify(item, null, 2)}`);
        item.createdInView = this.mx_isZueri9View ? 'zueri9' : 'dispo';
        this.$socket.emit('domain:create', DOMAIN, item, (response) => {
          this.pushDomainItem({ domain: DOMAIN, item: response.data });
          this.close();
        });
      }
    },
    save() {
      let d = this.currentDate;
      let t = new Date(this.editedItem.start);

      let startDate = this.editedItem.start;
      if (d.getTime && t.getTime) {
        startDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), t.getHours(), t.getMinutes());
      }

      let endDate = this.editedItem.end;
      let { id, vbzNr, assignedTo, betriebshofId, start, end, phone, remark } = this.editedItem;
      let sendItem = { ...this.editedItem, start: startDate, end: endDate };

      // console.debug('save pikett', JSON.stringify(sendItem, null, 2));
      if (sendItem.id) {
        // Update item
        sendItem.id = id;
        let itemAtIndex = this.items[this.editedIndex];
        this.$socket.emit('domain:update', DOMAIN, sendItem, (response) => {
          Object.assign(itemAtIndex, response.data);
          this.close();
        });
      } else {
        // Create item
        sendItem.recordDate = this.currentDate;
        sendItem.createdInView = this.mx_isZueri9View ? 'zueri9' : 'dispo';
        this.$socket.emit('domain:create', DOMAIN, sendItem, (response) => {
          this.pushDomainItem({ domain: DOMAIN, item: response.data });
          this.close();
        });
      }
    },
  },
  watch: {
    items(newValue, oldValue) {
      setTimeout(() => {
        this.items.forEach((i) => (i.receivedAt = 0));
      }, constants.showChangesDurationInSeconds * 1000);
    },
  },
};
</script>

<style>
.panel-card {
  transition: all ease-in-out 1s;
  overflow: scroll;
  margin: 0 !important;
  width: 100%;
}
.v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #90a4ae #eceff1;
}

.theme--light tr:has(td):has(div):has(.is-forwarded) {
  background: #dceffc;
}

.theme--dark tr:has(td):has(div):has(.is-forwarded) {
  background: #062a41;
}
</style>

<!-- Scoped is not working here because it would brake selectors like :has -->
<style scoped>
.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

td {
  padding: 0 2px !important;
}

.scroll-container {
  overflow-x: auto; /* Enables horizontal scrolling */
  width: 100%; /* Adjust width as needed */
  max-width: 100vw; /* Maximum width */
}

/* You can also add custom scrollbar styles if needed */
.scroll-container::-webkit-scrollbar {
  height: 8px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #888;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
